<template>
    <div class="form-container">
        <div class="check-phone-header">
            {{ $t('重置密码') }}
        </div>
        <div class="check-phone-tips">
            <p>{{ $t('修改{name}({account})的密码', { name: info.name, account: info.account }) }}</p>
        </div>
        <div class="tips">
            {{ $t('密码长度须8-16位，且包含以下情况的3种：大写字母、小写字母、数字、符号&、*、%等') }}
        </div>
        <v-form kind="desc" class="modifypwd-wrap">
            <v-form-item v-model="pwdFormatErrorTip" :label="$t('新密码')" name="password">
                <v-input
                    v-model="newPassword"
                    :class="{ 'input-error': !pwdValidate }"
                    :placeholder="$t('请输入新密码')"
                    password
                    @focus="onFocus"
                />
            </v-form-item>
            <v-form-item :label="$t('确认密码')" name="passwordnew">
                <v-input
                    v-model="repeatPassword"
                    :placeholder="$t('请再次输入新密码')"
                    password
                />
            </v-form-item>
            <div
                class="wrap-cell"
                style="text-align: center"
            >
                <v-button
                    v-if="showLastStep"
                    status="primary"
                    class="next-step-btn"
                    @click="lastStep"
                >
                    {{ $t('上一步') }}
                </v-button>
                <v-button
                    :loading="resetLoading"
                    status="primary"
                    class="next-step-btn"
                    @click="passwordValidate"
                >
                    {{ $t('重置密码') }}
                </v-button>
            </div>
        </v-form>

        <v-dialog
            v-model="resetSuccess"
            :title="$t('新密码设置成功')"
            kind="alert"
            status="success"
            @confirm="resetSuccessConfirm"
            @close="resetSuccessConfirm"
        />
    </div>
</template>
<script>
import md5 from '@/utils/md5.js';

const RES_PWD_URL = '/v1/basic.account.account_web.Account/UpdatePsw';
export default {
    name: 'ResetPassWord',
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
        showLastStep: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            newPassword: '',
            repeatPassword: '',
            pwdValidate: true, // true 通过
            pwdFormatErrorMsg: this.$t('密码最大长度为16位'),
            pwdErrorMsgMap: {
                0: this.$t('密码不能为空'),
                1: this.$t('密码不能小于8位'),
                2: this.$t('密码超出最大长度'),
                3: this.$t('输入不符合强度要求'),
                4: this.$t('两次密码输入不同'),
                5: this.$t('重置密码失败'),
            },
            resetSuccess: false,
            resetLoading: false,
        };
    },
    computed: {
        pwdFormatErrorTip() {
            return this.pwdValidate ? '' : this.pwdFormatErrorMsg;
        },
    },
    created() {
        // console.log('reset', this.info);
    },
    methods: {
        onFocus() {
            this.pwdValidate = true;
        },
        passwordValidate() {
            const value = this.newPassword.trim();
            const { pwdErrorMsgMap } = this;
            if (value === '') {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['0'];
                this.pwdValidate = false;
            } else if (value.length < 8) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['1'];
                this.pwdValidate = false;
            } else if (value.length > 16) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['2'];
                this.pwdValidate = false;
            } else if (
                !/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).+|(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).+|(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).+|(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).+)$/.test(value)
            ) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['3'];
                this.pwdValidate = false;
            } else if (value !== this.repeatPassword) {
                this.pwdFormatErrorMsg = pwdErrorMsgMap['4'];
                this.pwdValidate = false;
            } else {
                this.pwdValidate = true;
                this.resetPassWord();
            }
        },
        customFn(res) {
            this.resetLoading = false;
            this.$message.error(res.message);
        },
        resetPassWord() {
            const params = {
                mobile: this.info.phoneNumber,
                sms_code: this.info.verifyCode,
                aid: this.info.aid,
                password: md5(this.repeatPassword),
                pwd_len: this.repeatPassword.length,
            };
            this.$ajax.gatewayPost(RES_PWD_URL, params, { customFn: this.customFn }
            ).then((res) => {
                if (res && res.code === 0) {
                    // 重置成功的面板
                    this.resetLoading = false;
                    this.resetSuccess = true;
                } else {
                    this.resetLoading = false;
                    this.$message.warning(res.message);
                }
            })
                .catch((err) => {
                    this.resetLoading = false;
                    this.$message.warning(err.message);
                });
        },
        lastStep() {
            this.$emit('reback');
        },
        resetSuccessConfirm() {
            // 跳转到登录按钮
            window.open(`https://${window.location.hostname}/ac/login`, '_self');
        },
    },
};
</script>
<style lang="less" scoped>
@import '../style.less';
.tips {
    padding: 0 24px;
    color: var(--text---color-text-secondary, rgba(1, 10, 40, 0.65));
}
.modifypwd-wrap {
    margin-top: 20px !important;

    /deep/ .v-input--default {
        width: 100%;
    }
    .wrap-cell {
        text-align: unset;
        .input-border {
            width: 340px;
        }
        .next-step-btn {
            margin: 40px 10px 45px;
        }
    }
    .wrap-cell-large {
        margin-left: 56px;
        p {
            width: 56px;
            text-align: left;
        }
    }
}
</style>
